<p>{{ 'alerts.error occurred' | transloco }}</p>
<a
  [routerLink]="['/intern/transcr/']"
  class="btn btn-info btn-sm btn-raised"
  fragment="feedback"
>
  <i class="fa-solid fa-paper-plane"></i>
  <span> {{ 'g.Send feedback' | transloco }}</span>
</a>
